/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Pre_Vetting_TitleInputs */



/**
* | output |
* | --- |
* | "Pre-vetting inspections" |
*
* @param {Service_Pre_Vetting_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_pre_vetting_title = /** @type {((inputs?: Service_Pre_Vetting_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Pre_Vetting_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("预审查检查")
	return /** @type {LocalizedString} */ ("Pre-vetting inspections")
});